__turbopack_context__.v({
  "chartCircle": "TTFGZq_chartCircle",
  "circle": "TTFGZq_circle",
  "circleBg": "TTFGZq_circleBg",
  "circularChart": "TTFGZq_circularChart",
  "percentage": "TTFGZq_percentage",
  "progress": "TTFGZq_progress",
});
